module.exports = __webpack_public_path__ + "static/media/work-8.efc11d77.png";